import React from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import RouteProvider from "../RouteProvider";
import routes from "../../routes";

const Router = () => (
  <BrowserRouter>
    <RouteProvider value={routes}>
      {context => (
        <Switch>
          {context.routes.map(route => (
            <Route key={route} exact {...route} />
          ))}
        </Switch>
      )}
    </RouteProvider>
  </BrowserRouter>
);

export default Router;
